import { useCallback, useEffect, useRef } from 'react';
import { MetricEvents, updateTimer } from '../../../common/metrics';
import { fmtComponentName } from '../../../common/utils';
import { useNavComponentsManager } from '../useNavComponentsManager';
export const useLifecycleTimers = componentName => {
  const {
    onComponentStatesMapChange,
    isLoaded,
    metricsStartTime
  } = useNavComponentsManager();
  const isInitiallyLoaded = isLoaded(componentName);
  const loadRequestedTime = useRef(metricsStartTime);
  const loadCompletedTime = useRef(0);
  const formattedComponentName = fmtComponentName(componentName);
  useEffect(() => {
    const unsubscribe = onComponentStatesMapChange(shouldLoad => {
      if (isInitiallyLoaded) {
        return;
      }
      if (shouldLoad) {
        loadRequestedTime.current = performance.now();
        unsubscribe();
      }
    }, ({
      [componentName]: {
        isLoaded: shouldLoad
      }
    }) => shouldLoad);
    return unsubscribe;
  }, [componentName, isInitiallyLoaded, onComponentStatesMapChange]);
  const updateTimerLoaded = useCallback(() => {
    const {
      endTime
    } = updateTimer({
      event: MetricEvents.LOADED,
      componentName: formattedComponentName,
      startTime: loadRequestedTime.current
    });
    loadCompletedTime.current = endTime;
  }, [formattedComponentName]);
  const updateTimerReady = useCallback(() => {
    updateTimer({
      event: MetricEvents.READY,
      componentName: formattedComponentName,
      startTime: loadCompletedTime.current
    });
  }, [formattedComponentName]);
  return {
    updateTimerLoaded,
    updateTimerReady
  };
};